<template>
  <div :key="key">
    <McButton
      variant="secondary"
      text=""
      :icon="icon"
      :id="`popover-collapse-button-${id}`"
      @click="$emit('click')"
    />
    <b-popover
      custom-class="popover-collapse-button"
      triggers="hover"
      placement="left"
      :target="`popover-collapse-button-${id}`"
    >
      <template #default> {{ text }} </template>
    </b-popover>
  </div>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    id: {
      type: String,
      default: '1',
    },
    value: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['click'],
  data() {
    return {
      key: 1,
    }
  },
  computed: {
    text() {
      return this.value ? 'Collapse' : 'Expand'
    },
    icon() {
      return this.value ? 'icon-outline_collapse' : ' icon-outline_expand'
    },
  },
  watch: {
    value() {
      this.key += 1
    },
  },
}
</script>

<style lang="scss" scoped>
.popover-collapse-button {
  :deep(.popover-body) {
    background-color: #344264;
    padding: 8px 10px 8px 10px;
    font-size: 12px;
    border-radius: 8px;
    color: $white;
  }
}
</style>
